import type { BotDoc } from '@spirits/shared';

export interface BotWithLock {
  bot: BotDoc & { id: string };
  locked: boolean;
  // The undecided bot with the lowest order < this bot's order. Used to render
  // "✦ {name} decides first" placeholders.
  blockedBy: (BotDoc & { id: string }) | null;
}

// Sort bots by order ascending, then by id for stability. A bot is locked iff
// any strictly-lower-ordered bot in the same scene is still `deciding`. Bots
// that share an order act in parallel and never block each other.
export function withLocks(bots: Array<BotDoc & { id: string }>): BotWithLock[] {
  const sorted = [...bots].sort((a, b) => {
    if (a.order !== b.order) return a.order - b.order;
    return a.id.localeCompare(b.id);
  });
  return sorted.map((bot) => {
    const blocker = sorted.find(
      (other) => other.order < bot.order && other.decisionState === 'deciding',
    );
    return { bot, locked: !!blocker, blockedBy: blocker ?? null };
  });
}
